import React, { useEffect } from 'react';
import './App.less';
import { BrowserRouter, Switch } from 'react-router-dom';
import Router from '@/components/Router';
import MyProvider from './stores';
import { Container } from './styled';

import VConsole from 'vconsole';
import { showTip } from './scenes/Common/method';
import { Toast } from 'antd-mobile';
if (!!process.env.REACT_APP_vConsole || process.env.REACT_APP_ENV !== 'prod') {
  const vConsole = new VConsole();
}

function App() {
  return (
    <Container className="subApp">
      <MyProvider>
        <BrowserRouter>
          <Switch>
            <Router />
          </Switch>
        </BrowserRouter>
      </MyProvider>
    </Container>
  );
}

export default App;
